import React from 'react';
import { useNavigate } from 'react-router-dom';

const AboutPage = () => {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh',
      width: '100%',
      fontFamily: "'Nunito', sans-serif",
      backgroundColor: '#F4ABBA',
      color: '#333',
      padding: '40px 20px',
      paddingTop: '100px'
    }}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        <button
          onClick={() => navigate('/')}
          style={{
            backgroundColor: 'white',
            color: '#DD2E44',
            padding: '10px 25px',
            borderRadius: '20px',
            border: '2px solid #DD2E44',
            fontSize: '16px',
            fontWeight: '700',
            cursor: 'pointer',
            marginBottom: '40px'
          }}
        >
          ← Back to Home
        </button>

        <div style={{
          backgroundColor: 'white',
          padding: '60px',
          borderRadius: '25px',
          boxShadow: '0 8px 30px rgba(0,0,0,0.1)',
          marginBottom: '40px'
        }}>
          <h1 style={{
            fontSize: '48px',
            fontWeight: '800',
            color: '#DD2E44',
            marginBottom: '30px',
            textAlign: 'center'
          }}>
            About Paria.ai
          </h1>
          
          <div style={{ fontSize: '20px', lineHeight: '1.8', color: '#555' }}>
            <p style={{ marginBottom: '25px' }}>
              Welcome to <strong style={{ color: '#DD2E44' }}>Paria.ai</strong> - a pedagogically sound, interactive language-learning platform designed for children aged 6-11. We teach <strong>English to Farsi speakers</strong> and <strong>Farsi to English speakers</strong> through play-based learning experiences.
            </p>
            
            <h2 style={{
              fontSize: '32px',
              fontWeight: '700',
              color: '#DD2E44',
              marginTop: '40px',
              marginBottom: '20px'
            }}>
              Our Philosophy
            </h2>
            <p style={{ marginBottom: '25px' }}>
              At Paria.ai, we believe learning should be <strong>joyful, effective, and pedagogically sound</strong>. This is NOT a traditional school-style app. It is a <strong>learning-through-play ecosystem</strong> where children feel safe to speak, learn through play, and build real communication skills.
            </p>

            <h2 style={{
              fontSize: '32px',
              fontWeight: '700',
              color: '#DD2E44',
              marginTop: '40px',
              marginBottom: '20px'
            }}>
              Two Pedagogical Groups
            </h2>
            <p style={{ marginBottom: '25px' }}>
              Our platform clearly separates learners into two groups based on cognitive development:
            </p>
            
            <div style={{
              backgroundColor: '#FFF5F7',
              padding: '30px',
              borderRadius: '20px',
              marginBottom: '25px'
            }}>
              <h3 style={{
                fontSize: '24px',
                fontWeight: '700',
                color: '#DD2E44',
                marginBottom: '15px'
              }}>
                👶 Group A: Early & Emerging Learners (Ages 6-8)
              </h3>
              <p style={{ marginBottom: '15px' }}>
                <strong>Key Characteristics:</strong> Very play-based, short attention span, concrete thinking, understand meaning before producing language.
              </p>
              <p style={{ marginBottom: '15px' }}>
                <strong>Learning Focus:</strong> Listening & speaking, sounds, rhythm, repetition, visuals + movement.
              </p>
              <p>
                <strong>Teaching Methods:</strong> Songs & chants, storytelling with pictures, role-play & movement games, flashcards + physical actions, TPR (Simon Says, act-it-out games).
              </p>
            </div>

            <div style={{
              backgroundColor: '#FFF5F7',
              padding: '30px',
              borderRadius: '20px',
              marginBottom: '25px'
            }}>
              <h3 style={{
                fontSize: '24px',
                fontWeight: '700',
                color: '#DD2E44',
                marginBottom: '15px'
              }}>
                🧠 Group B: Expanding Thinkers & Pre-Teens (Ages 9-11)
              </h3>
              <p style={{ marginBottom: '15px' }}>
                <strong>Key Characteristics:</strong> More logical and reflective, can follow rules and multi-step instructions, enjoy challenges and competition, begin noticing grammar patterns.
              </p>
              <p style={{ marginBottom: '15px' }}>
                <strong>Learning Focus:</strong> Reading short texts independently, purposeful speaking, early writing & structure, problem-solving.
              </p>
              <p>
                <strong>Teaching Methods:</strong> Projects (posters, mini-presentations), games with rules, story sequencing & story cubes, scenario-based role-play, simple creative writing.
              </p>
            </div>

            <h2 style={{
              fontSize: '32px',
              fontWeight: '700',
              color: '#DD2E44',
              marginTop: '40px',
              marginBottom: '20px'
            }}>
              Core Learning Modules
            </h2>
            <ul style={{ marginLeft: '30px', marginBottom: '25px', fontSize: '18px', lineHeight: '2' }}>
              <li style={{ marginBottom: '10px' }}>
                <strong>🔤 Vocabulary & Sounds:</strong> Alphabet, vocabulary, letter sounds, guided writing
              </li>
              <li style={{ marginBottom: '10px' }}>
                <strong>👂 Listening & Speaking:</strong> Comprehension before production, pronunciation through repetition
              </li>
              <li style={{ marginBottom: '10px' }}>
                <strong>📚 Reading & Comprehension:</strong> Short readable texts with visual support (primarily 9-11)
              </li>
              <li style={{ marginBottom: '10px' }}>
                <strong>📖 Storytelling with Pictures:</strong> Learn through stories, visuals, and sequencing
              </li>
              <li style={{ marginBottom: '10px' }}>
                <strong>💬 Conversation & Small Talk:</strong> Build confidence in real-life communication
              </li>
            </ul>

            <h2 style={{
              fontSize: '32px',
              fontWeight: '700',
              color: '#DD2E44',
              marginTop: '40px',
              marginBottom: '20px'
            }}>
              Pedagogical Rules
            </h2>
            <ul style={{ marginLeft: '30px', marginBottom: '25px', fontSize: '18px', lineHeight: '2' }}>
              <li style={{ marginBottom: '10px' }}>No grammar-heavy explanations for ages 6-8</li>
              <li style={{ marginBottom: '10px' }}>Listening always comes before speaking</li>
              <li style={{ marginBottom: '10px' }}>Speaking before reading</li>
              <li style={{ marginBottom: '10px' }}>Reading before writing</li>
              <li style={{ marginBottom: '10px' }}>Clear separation of age groups in content & UI</li>
            </ul>

            <h2 style={{
              fontSize: '32px',
              fontWeight: '700',
              color: '#DD2E44',
              marginTop: '40px',
              marginBottom: '20px'
            }}>
              What Makes Us Different
            </h2>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
              gap: '30px',
              marginTop: '30px'
            }}>
              <div>
                <div style={{ fontSize: '48px', marginBottom: '15px' }}>🎮</div>
                <h3 style={{ fontSize: '24px', fontWeight: '700', color: '#DD2E44', marginBottom: '10px' }}>
                  Play-Based Learning
                </h3>
                <p style={{ fontSize: '16px', color: '#666' }}>
                  Learning through games and interactive activities makes education enjoyable and memorable.
                </p>
              </div>
              <div>
                <div style={{ fontSize: '48px', marginBottom: '15px' }}>📚</div>
                <h3 style={{ fontSize: '24px', fontWeight: '700', color: '#DD2E44', marginBottom: '10px' }}>
                  Story-Based Approach
                </h3>
                <p style={{ fontSize: '16px', color: '#666' }}>
                  Stories capture imagination and help children understand language in context.
                </p>
              </div>
              <div>
                <div style={{ fontSize: '48px', marginBottom: '15px' }}>🏆</div>
                <h3 style={{ fontSize: '24px', fontWeight: '700', color: '#DD2E44', marginBottom: '10px' }}>
                  Gamified Experience
                </h3>
                <p style={{ fontSize: '16px', color: '#666' }}>
                  Stars, badges, and progress tracking motivate children to keep learning.
                </p>
              </div>
            </div>

            <div style={{
              marginTop: '50px',
              padding: '30px',
              backgroundColor: '#FFF5F7',
              borderRadius: '20px',
              textAlign: 'center'
            }}>
              <p style={{ fontSize: '24px', fontWeight: '600', color: '#DD2E44', marginBottom: '20px' }}>
                Ready to start learning?
              </p>
              <button
                onClick={() => navigate('/dashboard/learning-hub')}
                style={{
                  backgroundColor: '#DD2E44',
                  color: 'white',
                  padding: '20px 50px',
                  borderRadius: '25px',
                  border: 'none',
                  fontSize: '20px',
                  fontWeight: '700',
                  cursor: 'pointer',
                  boxShadow: '0 6px 20px rgba(221, 46, 68, 0.3)'
                }}
              >
                Access Dashboard 🔒
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;